var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orgErrorMessage && _vm.orgErrorMessage !== '')?_c('div',{staticClass:"error-area",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isStickyWidth: _vm.isStickyWidth,
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en'
  },domProps:{"innerHTML":_vm._s(_vm.orgErrorMessage)},on:{"click":_vm.onClickErrorLink}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }